import React from "react";
import styles from "./FormFieldInputNew.module.scss";
import classNames from "classnames";

const FormFieldInputButton = React.forwardRef(({ Icon, label, className, style, children, ...rest }, forwardRef) => {
    return <button ref={forwardRef} type="button" className={classNames(styles["form-field-input-button"], className, { [styles["icon-only"]]: !label})} style={style} {...rest}>
        {Icon && <Icon/>}
        {label && <span className={styles["label"]}>{label}</span>}
        {children}
    </button>
})

export default FormFieldInputButton;
